import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PermissionsActions } from '../state/permissions/premissions.actions';
import { PermissionsService } from '../../services/permissions.service';
import { catchError, of, switchMap } from 'rxjs';

export const getPermissions$ = createEffect(
  (
    actions$ = inject(Actions),
    permissionsService = inject(PermissionsService),
  ) => {
    return actions$.pipe(
      ofType(PermissionsActions.getUserPermissions),
      switchMap(() =>
        permissionsService.getUserPermissions().pipe(
          switchMap((res) => [
            PermissionsActions.getUserPermissionsSuccess(res),
          ]),
          catchError(() => of(PermissionsActions.getUserPermissionsFail())),
        ),
      ),
    );
  },
  { functional: true },
);
